var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarePlanMedicationProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 21.9583H10.6249C8.64787 21.9583 7.65935 21.9583 6.85497 22.2023C5.0439 22.7517 3.62664 24.169 3.07726 25.98C2.83325 26.7844 2.83325 27.773 2.83325 29.75M20.5416 10.625C20.5416 14.1458 17.6874 17 14.1666 17C10.6458 17 7.79158 14.1458 7.79158 10.625C7.79158 7.10419 10.6458 4.25 14.1666 4.25C17.6874 4.25 20.5416 7.10419 20.5416 10.625Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0795 24.0097C22.9466 22.7219 21.0573 22.3755 19.6377 23.5547C18.2182 24.7339 18.0184 26.7055 19.1331 28.1001C20.2479 29.4947 24.0795 32.7497 24.0795 32.7497C24.0795 32.7497 27.9112 29.4947 29.0259 28.1001C30.1407 26.7055 29.9653 24.7215 28.5213 23.5547C27.0774 22.3879 25.2125 22.7219 24.0795 24.0097Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePlanMedicationProfile);
export default __webpack_public_path__ + "static/media/carePlanMedicationProfile.3e03b27a04bec36d53fc3aa49885b46e.svg";
export { ForwardRef as ReactComponent };